module.exports = __webpack_public_path__ + "static/img/2.ed4960f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/2.png
// module id = boHQ
// module chunks = 1